import { createSlice } from '@reduxjs/toolkit'
// import axios from 'axios'
// import { useCookies } from 'react-cookie'
// import { Cookies } from 'react-cookie'
// import moment from 'moment'
import api, { TOKEN_FIELD_STORAGE, BASE_URL } from '../../api/index'
import { startLoading, stopLoading } from './loadingSlice'
import { failed, success } from './snackSlice'
import i18n from '../../i18n'
import { getUserPackages } from './packageSlice'

// const cookies = new Cookies()

export const userSlice = createSlice({
  name: 'user',
  initialState: { init: true },
  reducers: {
    userFetched: (state, { payload }) => payload,
    userRegisterForm(state, action) {
      state.registerForm = action.payload
    },
    userResetPasswordForm(state, action) {
      state.resetPasswordForm = action.payload
    },
    userProfileFetched: (state, { payload }) => {
      state.userProfile = payload
    },
    userAddress(state, action) {
      state.userAddress = action.payload
    },
    userProfileFailedToFetch: (state) => {
      return { ...state, init: false }
    },
    userProfileDetailsFetched: (state, { payload }) => {
      state.userDetails = payload
    },
    userStateFetched: (state, { payload }) => {
      // usually this should occure after getting profile, so it is ok to update state
      // return { ...state, state: payload }
      state.userState = payload
    },
    userLogout: () => {
      return {}
    },
  },
})

export default userSlice.reducer

export const {
  userFetched,
  userRegisterForm,
  userResetPasswordForm,
  userProfileFetched,
  userLogout,
  userProfileFailedToFetch,
  userStateFetched,
  userAddress,
  userProfileDetailsFetched,
} = userSlice.actions

export const logout = () => (dispatch) => {
  localStorage.removeItem(TOKEN_FIELD_STORAGE)
  localStorage.removeItem('token_expire')
  // cookies.remove(TOKEN_FIELD_STORAGE)
  dispatch(userLogout())
}

export const login = (logeinInfo, navigate, remember) => (dispatch) => {
  dispatch(startLoading())
  // const [setCookie] = useCookies([TOKEN_FIELD_STORAGE])

  api({
    data: logeinInfo,
    url: '/Account/User/Login',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
  })
    .then((res) => {
      dispatch(success(i18n.t('login_successful')))
      dispatch(stopLoading())
      const { data } = res?.data
      if (data) {
        if (remember) {
          // cookies.set(TOKEN_FIELD_STORAGE, data?.accessToken,
          //   { path: '/', expires: new Date(data?.expires) })
          localStorage.setItem(TOKEN_FIELD_STORAGE, data?.accessToken)
          localStorage.setItem('token_expire', new Date(data?.expires).getTime())
        } else {
          // cookies.set(TOKEN_FIELD_STORAGE, data?.accessToken,
          //   { path: '/', expires: new Date(new Date().setDate(new Date().getDate() + 1)) })
          localStorage.setItem(TOKEN_FIELD_STORAGE, data?.accessToken)
          localStorage.setItem('token_expire', new Date(new Date().setDate(new Date().getDate() + 1)).getTime())
        }

        // localStorage.setItem(TOKEN_FIELD_STORAGE, data?.accessToken)
        dispatch(userFetched(data?.userInfo))
      }
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message ?? ''))
    })
}

export const changePass = (data, cb) => (dispatch) => {
  dispatch(startLoading())

  api({
    data,
    url: `${BASE_URL}/account/user/password/change`,
    method: 'put',
    headers: { 'Content-Type': 'application/json' },
  })
    .then(() => {
      dispatch(stopLoading())
      dispatch(success('رمزعبور با موفقیت تغییر کرد'))
      if (cb) cb()
    })
    .catch((e) => {
      dispatch(stopLoading())
      // dispatch(failed(err?.response?.status === 401 ?
      // 'رمزعبور فعلی اشتباه است' : err?.response?.message || 'مشکلی پیش آمد. مجددا تلاش کنید'))
      dispatch(failed(e?.response?.data?.message ?? ''))
      if (cb) cb()
    })
}

export const getProfile = () => (dispatch) => {
  dispatch(startLoading())
  api.get('Account/User/info')
    .then((res) => {
      dispatch(stopLoading())
      dispatch(userFetched(res?.data.data))
    })
    .catch((e) => {
      dispatch(userProfileFailedToFetch())
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message ?? ''))
    })
}

export const getUserProfileInfo = () => (dispatch) => {
  dispatch(startLoading())
  api.get('account/user/profile/info')
    .then((res) => {
      dispatch(stopLoading())
      dispatch(userProfileFetched(res?.data?.data))
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message))
    })
}

export const updateProfile = (formData, callBack) => (dispatch) => {
  dispatch(startLoading())
  api({
    method: 'put',
    url: 'Account/User/Profile',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
    .then(() => {
      dispatch(stopLoading())
      dispatch(success('ویرایش با موفقیت انجام شد'))
      if (callBack && typeof (callBack) === 'function') callBack()
      // dispatch(getProfile())
    })
    .catch((e) => {
      dispatch(stopLoading())
      // dispatch(failed(e?.response?.data?.message ?? 'خطا در ویرایش پروفایل'))
      dispatch(failed(e?.response?.data?.message))
      // if (e?.response?.data?.message === 'Please add an address first.') {
      //   dispatch(failed('لطفا ادرس خود را وارد کنید'))
      // } else {
      //   // dispatch(failed(e?.response?.data?.message ?? 'خطا در ویرایش پروفایل'))
      //   dispatch(failed(e?.response?.data?.message))
      // }
    })
}

export const registerUser = (t, values, callback) => (dispatch) => {
  const url = 'account/user/register'
  dispatch(startLoading())
  api
    .post(url, values)
    .then(() => {
      dispatch(success(t('code_was_sent_to_you')))
      dispatch(userRegisterForm(values))
      dispatch(stopLoading())
      if (callback && typeof (callback) === 'function') callback()
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      dispatch(stopLoading())
      return 'error'
    })
}

export const getUserAddresses = () => (dispatch) => {
  const url = 'User/Address'
  dispatch(startLoading())
  api
    .get(url)
    .then((res) => {
      console.log(res)
      // dispatch(success(t('code_was_sent_to_you')))
      dispatch(userAddress(res?.data))
      dispatch(stopLoading())
      // if (callback && typeof (callback) === 'function') callback()
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
      return 'error'
    })
}

export const addUserAddress = (values) => (dispatch) => {
  const url = 'User/Address'
  dispatch(startLoading())
  api
    .post(url, values)
    .then(() => {
      dispatch(success(i18n.t('addAddress_successfuly')))
      dispatch(getUserAddresses())
      dispatch(userAddress(values))
      dispatch(stopLoading())
      // if (callback && typeof (callback) === 'function') callback()
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
      return 'error'
    })
}

export const editUserAddress = (values) => (dispatch) => {
  const url = 'User/Address'
  dispatch(startLoading())
  api
    .put(url, values)
    .then(() => {
      // dispatch(success(t('code_was_sent_to_you')))
      dispatch(getUserAddresses())
      dispatch(userAddress(values))
      dispatch(stopLoading())
      // if (callback && typeof (callback) === 'function') callback()
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
      return 'error'
    })
}

export const deleteUserAddresses = (id) => (dispatch) => {
  const url = `User/Address/${id}`
  dispatch(startLoading())
  api
    .delete(url)
    .then((res) => {
      dispatch(getUserAddresses())

      // dispatch(success(t('code_was_sent_to_you')))
      dispatch(userAddress(res?.data))
      dispatch(stopLoading())
      // if (callback && typeof (callback) === 'function') callback()
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
      return 'error'
    })
}

export const getUserDetailsById = (id) => (dispatch) => {
  const url = `Account/User/${id}`
  dispatch(startLoading())
  api
    .get(url)
    .then((res) => {
      console.log(res)
      dispatch(userProfileDetailsFetched(res))
      dispatch(stopLoading())
      // if (callback && typeof (callback) === 'function') callback()
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
      return 'error'
    })
}

export const confirmSMS = (values, callback) => (dispatch) => {
  const url = 'account/user/register/confirm'
  dispatch(startLoading())
  api
    .post(url, values)
    .then((res) => {
      dispatch(success(i18n.t('register_successfuly')))
      dispatch(stopLoading())
      const { data } = res?.data
      if (data) {
        localStorage.setItem(TOKEN_FIELD_STORAGE, data?.accessToken)
        localStorage.setItem('token_expire', new Date(new Date().setDate(new Date().getDate() + 1)).getTime())
        // localStorage.setItem(TOKEN_FIELD_STORAGE, data?.accessToken)
        // cookies.set(TOKEN_FIELD_STORAGE, data?.accessToken,
        //   { path: '/', expires: new Date(data?.expires) })
        dispatch(getUserPackages(callback))
      }
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const resetPasswordByUsername = (t, values, callback) => (dispatch) => {
  const url = '/account/user/password/reset/byUserName'
  dispatch(startLoading())
  api
    .post(url, values)
    .then(() => {
      dispatch(success(t('code_was_sent_to_you')))
      dispatch(userResetPasswordForm(values))
      dispatch(stopLoading())
      if (callback && typeof (callback) === 'function') callback()
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const resetPasswordConfirm = (t, values, callback) => (dispatch) => {
  const url = 'account/user/password/reset/confirm'
  dispatch(startLoading())
  api
    .post(url, values)
    .then(() => {
      dispatch(success(t('change_password_successfuly')))
      dispatch(stopLoading())
      if (callback && typeof (callback) === 'function') callback()
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getUserState = (callback) => (dispatch) => {
  const url = 'account/user/state'
  dispatch(startLoading())
  api
    .get(url)
    .then((res) => {
      dispatch(stopLoading())
      dispatch(userStateFetched(res?.data?.data))
      if (callback && typeof (callback) === 'function') callback()
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const selectRegisterForm = (state) => state.user.registerForm
export const selectResetPasswordForm = (state) => state.user.resetPasswordForm
export const selectUserInfo = (state) => state.user
export const selectorUserProfile = (state) => state.user.userProfile
export const selectorUserAddress = (state) => state.user.userAddress
export const selectorUserDetails = (state) => state.user.userDetails
export const selectorUserState = (state) => state.user.userState
